module.exports = __webpack_public_path__ + "static/media/interchange.deb34c58.svg";